import { render } from "./StreakLeaderboardComponent.vue?vue&type=template&id=171d0836&scoped=true&ts=true"
import script from "./StreakLeaderboardComponent.vue?vue&type=script&lang=ts"
export * from "./StreakLeaderboardComponent.vue?vue&type=script&lang=ts"

import "./StreakLeaderboardComponent.vue?vue&type=style&index=0&id=171d0836&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171d0836"]])

export default __exports__